"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setStartDirection = _useStylesUtils.setStartDirection;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccSelectFilterStyle = (0, _react.useMemo)(function () {
    var deviceProps = function deviceProps() {
      var marginInlineStart = isMobileView ? pxToRem(22) : 0;
      var marginInlineEnd = isMobileView ? pxToRem(22) : 0;
      var height = isMobileView ? pxToRem(48) : pxToRem(36);
      return {
        marginInlineStart: marginInlineStart,
        marginInlineEnd: marginInlineEnd,
        height: height
      };
    };
    var contentDeviceProps = function contentDeviceProps() {
      var transform = isMobileView ? 'none' : "translateY(".concat(pxToRem(-10), ")");
      var borderRadius = isMobileView ? pxToRem(5) : pxToRem(19);
      var top = isMobileView ? 0 : pxToRem(-2);
      return {
        transform: transform,
        borderRadius: borderRadius,
        top: top
      };
    };
    var ccSelectFilter = (0, _css.css)(_objectSpread({
      position: 'relative'
    }, deviceProps()));
    var ccSelectFilterContent = (0, _css.css)(_objectSpread(_objectSpread(_objectSpread({
      boxSizing: 'border-box',
      width: "calc(100% + ".concat(pxToRem(28), ")"),
      height: pxToRem(36),
      padding: "".concat(pxToRem(5), " ").concat(pxToRem(12)),
      position: 'absolute'
    }, setStartDirection(-14)), {}, {
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border),
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
      overflow: 'hidden'
    }, contentDeviceProps()), {}, {
      input: {
        margin: 0,
        boxSizing: 'border-box',
        height: '100%',
        border: 'none',
        outline: 'none',
        flex: 'auto',
        fontSize: pxToRem(15),
        paddingInlineEnd: pxToRem(12),
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
      }
    }));
    return {
      ccSelectFilter: ccSelectFilter,
      ccSelectFilterContent: ccSelectFilterContent
    };
  }, [isMobileView, pxToRem, setStartDirection, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText]);
  return {
    'cc-Select__filter': ccSelectFilterStyle.ccSelectFilter,
    'cc-Select__filter-content': ccSelectFilterStyle.ccSelectFilterContent
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;